export default __webpack_public_path__ + "static/media/BANNER01.68e66dab.png";